import { 
    GET_MATCH,
    GET_MATCHES,
    SET_MATCHES,
    SET_LAST_MATCHES,
    MATCH_ERROR,
    CLEAR_MATCHES,
    CLEAR_MATCH,
    MATCHES_LOADING,
    UPDATE_MATCH,
    MATCH_UPDATE_LOADED,
    MATCH_UPDATE_LOADING,
    SET_SHOW_BOTTOM_SPINNER_4_MATCHES,
    SET_LAST_MATCH_DOC,
    SET_NO_MORE_MATCHES
} from "../actions/types";

const initialState = {
    sports_match: null,
    matches: [],
    no_more_matches: false,
    show_bottom_spinner: false,
    last_page_doc: 0,
    loading: true,
    modal_loading: true,
    match_update_loading: false,
    error: {}
}

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch(type) {
        case MATCHES_LOADING:

            // Set the loading state to true
            return {
                ...state,
                loading: true
            };
        case MATCH_UPDATE_LOADING:

            return {
                ...state,
                match_update_loading: true,
            }
        case MATCH_UPDATE_LOADED:

            return {
                ...state,
                match_update_loading: false,
            }
        case GET_MATCH:

            // Set the sports_match state to the payload value and set loading to false
            return {
                ...state,
                sports_match: payload,
                loading: false
            }
        case GET_MATCHES:

            // Set the matches state to the payload value,
            // mark all matches as read, and set loading to false
            return {
                ...state,
                matches: payload,
                loading: false
            }
        case SET_MATCHES: {

            // Merge the existing matches with the payload matches,
            // and update the matches state accordingly
            const matches = action.payload;
            let tempMatches = matches; 
            
            if(state.matches.length > 0) {
                tempMatches= [...state.matches, ...tempMatches ];
            }

            return {
                ...state,
                matches: tempMatches,
                loading: false
            };
        }
        case SET_LAST_MATCHES: {

            // Merge the existing matches with the payload matches, and update the matches state
            const matches = action.payload;
            let tempMatches = matches; 
            
            if(state.matches.length > 0) {
                tempMatches= [...state.matches, ...tempMatches ];
            }

            return {
                ...state,
                matches: tempMatches,
                no_more_matches: true,
                loading: false
            };
        }
        case UPDATE_MATCH:

            // Update state with given sports_match data
            return {
                ...state,
                sports_match: payload
            }
        case MATCH_ERROR:

            // Set the error state to the payload value and set loading to false
            return {
                ...state,
                error: payload,
                loading: false,
            };
        case SET_SHOW_BOTTOM_SPINNER_4_MATCHES:
            return {
                ...state,
                show_bottom_spinner: payload
            };
        case SET_LAST_MATCH_DOC:

            return {
                ...state,
                last_page_doc: payload
            };
        case SET_NO_MORE_MATCHES:
            return {
                ...state,
                no_more_matches: payload
            };
        case CLEAR_MATCH:

            // Clear the notifications state and set loading to false
            return {
                ...state,
                sports_match: null,
                loading: false,
            }
        case CLEAR_MATCHES:

            // Clear the notifications state and set loading to false
            return {
                ...state,
                matches: [],
                loading: false,
            }
        default:
            return state;
    }
}